import React from 'react';

import { BodyLargeText, H3 } from 'playful-ui';

export const Master = () => (
  <React.Fragment>
    <H3 style={{ textAlign: 'center', alignSelf: 'center', marginTop: '32px' }}>Master moduli</H3>
    <BodyLargeText>
      <b>Master Product Designer</b> - Osmisli, razradi i izradi vlasititi dizajn robota u programu za 3D
      modeliranje (mehanika, 3D dizajn, printanje)
    </BodyLargeText>
    <BodyLargeText>
      <b>Master Gripper</b> - nadogradi STEMI robota hvataljkom vlastitog dizajna i izrade
      (3D printanje, razvoj mobilne aplikacije, programiranje robota)
    </BodyLargeText>
  </React.Fragment>
);
